import { render } from "./FeatureLevelSelection.vue?vue&type=template&id=56a4b2d6"
import script from "./FeatureLevelSelection.vue?vue&type=script&lang=js"
export * from "./FeatureLevelSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__